import deburr from "lodash/deburr";
const slugify = (string) => {
  return deburr(string).toLowerCase().trim().replace(/\s+/g, "-").replace(/&/g, "-and-").replace(/[^\w-]+/g, "").replace(/--+/g, "-");
};
export {
  slugify as default
};
//# sourceMappingURL=slugify.js.map
